import { Select } from "antd";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { LabelType } from "types/enums";

import { LabelTypeFilter, useLabelSelectOptions } from "./useLabelSelectOptions.ts";

interface LabelSelectSearchableProps extends SearchableSelectWrapperProps {
    labelType?: LabelTypeFilter;
    useNameAsValue?: boolean;
}

const getTranslationNamespace = (labelType: LabelTypeFilter): string => {
    switch (labelType) {
        case LabelType.Category:
            return "forms.general-fields.category";
        case LabelType.Label:
            return "forms.general-fields.tag";
        default:
            return "forms.general-fields.label";
    }
};

export const LabelSelectSearchable = ({ labelType = LabelType.Label, useNameAsValue = false, value, ...props }: LabelSelectSearchableProps) => {
    const { t: tCommon } = usePaldockTranslation("common");
    const hookResult = useLabelSelectOptions({ type: labelType, useNameAsValue });

    if (hookResult.loading && !hookResult.options.length) {
        // Don't pass value while loading to prevent showing raw UUIDs
        return (
            <Select
                size={props.size ?? "middle"}
                style={props.style}
                className={props.className}
                mode={props.mode}
                variant={props.variant}
                placeholder={tCommon("loading")}
                loading
                disabled
            />
        );
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace={getTranslationNamespace(labelType)}
            {...props}
            value={value}
            size={props.size ?? "middle"}
        />
    );
};
